import { Component, OnInit, Input, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';
// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { CommonService, ServiceWalkInService, SubscribeService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';

@Component({
    selector: 'servicephonetracking-tab',
    templateUrl: './servicePhoneTracking.component.html',
})

export class ServicePhoneTrackingComponent implements OnInit {
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        if(this.usertype != 'Super_Admin' && this.usertype != 'Admin'){
            this._params['mobile'] = this._params['disp_mobile'];
        }
        this.setPageData();
    }

    branchCtrl: FormControl;
    branchList: any[] = [];
    statusCtrl: FormControl;
    statusList: any[];
    minDate: any;
    phstatus: any;
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    usertype: any;

    columns: any = [];
    @Input() serviceInData: ServiceWalkInModel[] = [];
    @ViewChild('prodAutoComp') prodAutoComp;
    @ViewChild('searchComponent') searchComponent;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    itemList: any[] = [];
    isLoading: boolean = false;
    waitingStatusList: any[] = ['Waiting for Company Estimation', 'Company No Answer', 'Waiting for HeadOffice Estimation', 'Waiting for Client Approval', 'Client No Answer', 'Follow-up'];


    constructor(public store: Store<fromRootStore.State>,
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private serviceWalkInService: ServiceWalkInService, public subscribeService: SubscribeService
    ) {

        //this.getBranchList();
        function hasValidBranch(input: FormControl) {
            let branchID = input.value;
            let femp = _.find(this.branchList, { 'branch_id': branchID });
            if (femp)
                return null;
            return { inValidBranch: true };
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);


        function hasValidUnSold(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Waiting for Client Approval" && ledgerID != "Client Approved"
                && ledgerID != "Client No Answer" && ledgerID != "Client Not Ok" 
                && ledgerID != "Waiting for Company Estimation" && ledgerID != "Waiting for HeadOffice Estimation"
                && ledgerID != "Estimation Done" && ledgerID != "Company No Answer"
                && ledgerID != "Estimation To Client Done" && ledgerID != "Approval To Company Done"
                && ledgerID != "Approval To HeadOffice Done" && ledgerID != "Informed Delivery Done"
                && ledgerID != "New Machine" && ledgerID != "Follow-up") {
                retVal = { inValidStatus: true };
            }

            return retVal;
        }
        this.statusCtrl = new FormControl('', [
            Validators.required,
            hasValidUnSold.bind(this)
        ]);
        
       /* this.statusList = ['Waiting for Client Approval', 'Client Approved',
            'Client No Answer', 'Client Not Ok'];*/
    }

    ngOnInit(): void {

        let that = this;
        this.minDate = new Date(new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate());
        this.serviceInData['date'] = new Date();
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {

                return;
            }
            this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
                this.usertype = auth['usertype'];
                if (auth['islogin']) {
                    let branchs = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
                    that.branchList = _.filter(branchs, function (obj) { return obj['branch_id'] != auth['branch_id'] });
                }
            });
        });

        if (this._params['mode'] == 'Edit') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());

            this.serviceInData['date'] = new Date();
        }
        if (this._params['mode'] == 'Add') {
            //  this.loadAutoNumber();
        }
        this.serviceInData['random_no'] = this.getRandomInt(1, 500);
        /*this.columns = [
            { name: 'Date', prop: 'date', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'From Branch', prop: 'from_branch', width: 110, minWidth: 110, maxWidth: 110 },
            { name: 'To Branch', prop: 'to_branch', width: 110, minWidth: 110, maxWidth: 110 },
            { name: 'Status', prop: 'page_from', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Phone Status', prop: 'phone_status', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Description', prop: 'description', width: 200, minWidth: 200, maxWidth: 200 },

        ];*/
        this.columns = [
            {
                name: "Date",
                prop: "date",
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                toggle: true
            },
            {
                name: "Process",
                prop: "service_process",
                sortable: false,
                width: 280,
                minWidth: 280,
                maxWidth: 280
            },
            {
                name: "Status",
                prop: "service_status",
                sortable: false,
                //cellClass: "cell-left",
                width: 320,
                minWidth: 320,
                maxWidth: 320
            },
            {
                name: "Description",
                prop: "description",
                sortable: false,
                //cellClass: "cell-left",
                width: 260,
                minWidth: 260,
                maxWidth: 260
            }
        ];
        this.getPhonetrackStatus(this._params['ser_id'],this._params['phone_process']);
    }

    displayBranch(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                if (typeof branchID == 'string') {
                    branchID = parseInt(branchID);
                }
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }


    setPageData(): void {

        if (this._params != undefined) {
            let mode = this._params['mode'];
            if (mode == 'Edit') {
                let data = this._params;
                this.serviceInData = this._params;
                this.serviceInData['phone_status'] = '';

                this.serviceInData['date'] = new Date(this._params['date']);
                this.serviceInData['nxt_fol_date'] = new Date();
                //  this.prodList  = this._params['prodRes'];//new Date();

            }
            if(this._params['phone_process'] == 'Estimation From Company'){
             this.statusList = ['Waiting for Company Estimation', 'Estimation Done',
            'Company No Answer'];
        }
        else if(this._params['phone_process'] == 'Estimation From HeadOffice'){
            this.statusList = ['Waiting for HeadOffice Estimation', 'Estimation Done'];
        }
        else if(this._params['phone_process'] == 'Estimation To Client'){
            this.statusList = ['Client No Answer', 'Estimation To Client Done'];
        }
        else if(this._params['phone_process'] == 'Approval From Client'){
            this.statusList = ['Waiting for Client Approval', 'Client Approved',
            'Client No Answer', 'Client Not Ok', 'New Machine'];
        }
        else if(this._params['phone_process'] == 'Approval To Company'){
            this.statusList = ['Company No Answer',
            'Approval To Company Done'];
        }
        else if(this._params['phone_process'] == 'Approval To HeadOffice'){
            this.statusList = ['Approval To HeadOffice Done'];
        }
        else if(this._params['phone_process'] == 'Informed Delivery To Client'){
            this.statusList = ['Client No Answer','Informed Delivery Done', 'Follow-up'];
        }
        }
    }

    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(this.serviceInData['random_no'] + '_' + nextEl))) {
            nextEl = 'followup_status';
        }
        $('#' + this.serviceInData['random_no'] + '_' + nextEl).focus();
    }

    hasFollowupDate() {
        return this.waitingStatusList.includes(this.serviceInData['phone_status']);
    }

    onSaveImportExport() {
        let toast = {
            type: 'warning',
            title: 'WARNING',
        };

        /*          if (this.serviceInData['phone_status']!= 'Client No Answer' ) {
        
                    if(!(this.serviceInData['company_id'] && this.serviceInData['company_id']>0)) {
                        toast['body'] = 'Please Select To Branch';
                        this.toasterService.pop(toast);
                        return;
                    } else {
                       
                    }
                } */

        let that = this,
            mode = this._params['mode'];

        
        let testingDate = moment(this.serviceInData['date']).format('YYYY-MM-DD'),
            data = {
                ser_id: this.serviceInData['ser_id'],
/*                 to_branch: this.serviceInData['company_id'],
 */             phone_description: this.serviceInData['phone_description'],
                phone_status: this.serviceInData['phone_status'],
                phone_process: this.serviceInData['phone_process'],
                company_estimation_amount: this.serviceInData['company_estimation_amount'],
                customer_inform_amount: this.serviceInData['customer_inform_amount'],
                date: testingDate,
                mode: this._params['mode'],
                tabParams: this._params['tabParams'],
                to_branch: this._params['branch_id']
            };
        if (this.hasFollowupDate() && this.serviceInData['nxt_fol_date']) {
            data['nxt_fol_date'] = moment(this.serviceInData['nxt_fol_date']).format('YYYY-MM-DD');
        }
        this.isLoading = true;


        this.serviceWalkInService
            .addSaveImportExport(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.serviceInData = [];
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadServiceGrid();
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });

    }
    getPhonetrackStatus(id: any,phone_process:any) {
        let data = {
            start: 0,
            limit: 25,
            orderColumn: id,
            ser_id: id,
            phone_process: phone_process,
            orderDir: 'asc',
            view_type: 'Phone Tracking',
            from_page: 'Service Walk -in',
            bill_no: this.serviceInData['bill_no'],
            client_id: this.serviceInData['client_id']
        }
        let that = this;
        that.commonService
            .getTrackHistory(data)
            .then(function (res: any) {
                that.phstatus = res.data;
            });
    }
}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/servicePhoneTracking.component.ts